import { render, staticRenderFns } from "./ColumnEditor.vue?vue&type=template&id=1bc23d91&scoped=true"
import script from "./ColumnEditor.vue?vue&type=script&lang=js"
export * from "./ColumnEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc23d91",
  null
  
)

export default component.exports